import { useProfileContext } from '@contexts/profile'
import cogoToast from 'cogo-toast'
import { useMemo } from 'react'
import { Link, Share2 } from 'react-feather'
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share'

const Share = () => {
  const { profileDetails } = useProfileContext()
  const handleCopyLink = () => {
    navigator.clipboard.writeText(url)
    cogoToast.success('Profile link copied!', { hideAfter: 1.5 })
  }
  const url = useMemo(
    () => `https://codingal.com/@${profileDetails?.username}`,
    []
  )

  const SHARE_COPY = 'Check out my profile and amazing projects on Codingal - '
  return (
    <div className="flex space-x-3 items-center">
      <div className="flex items-center space-x-2">
        <Share2 className="w-5 lg:w-4 h-5 lg:h-4" />
        <span> Share profile</span>
      </div>
      <FacebookShareButton
        url={url}
        quote={SHARE_COPY}
        className="focus:outline-none"
      >
        <FacebookIcon className="w-6 lg:w-5 h-6 lg:h-5" borderRadius={10} />
      </FacebookShareButton>
      <WhatsappShareButton
        url={url}
        title={SHARE_COPY}
        className="focus:outline-none"
      >
        <WhatsappIcon className="w-6 lg:w-5 h-6 lg:h-5" borderRadius={10} />
      </WhatsappShareButton>
      <button onClick={handleCopyLink} className="focus:outline-none">
        <Link className="w-5 h-5" />
      </button>
    </div>
  )
}

export default Share
